import type { Effect, Reducer } from 'umi';
// import {codeMessage} from '@/utils/request';
import { queryPerson } from '@/services/user';
import { setAuthority, getMenu, getButtons, getPersonalAuthority } from '@/utils/authority';
import { LIQI_ROUTES } from '@/constant';
import { getAuthInfo } from '@/services/auth';
// import {getAuthUserInfo} from '@/services/auth'


export type ResourceItem = {
  id: string;
  name: string;
  path: string;
  children?: any[]
}


export type CurrentUser = {
  id?: string;
  name?: string;
  loginName?: string;
  resourceIds?: [];
  roleIds?: [] | null;
  remarks?: string;
  signature?: string;
  tags?: {
    key: string;
    label: string;
  }[];
  userid?: string;
  unreadCount?: number;
  resources: any[]

}

export type UserModelState = {
  currentUser?: CurrentUser;
  isLogin?: boolean;
  menuList?: any[];
  resourceMap?: any;
  authInfo:null | Record<string,any>
}

export type UserModelType = {
  namespace: 'user';
  state: UserModelState;

  reducers: {
    changLogin: Reducer<UserModelState>;
    saveCurrentUser: Reducer<UserModelState>;
    saveMenu: Reducer<UserModelState>;
    saveResourcesMap: Reducer<UserModelState>;
    saveRoutes: Reducer<UserModelState>;
    saveAuthInfo: Reducer<UserModelState>;
  };
}

const UserModel: UserModelType = {
  namespace: 'user',
  state: {
    currentUser: {
      resources:[],
    },
    isLogin: true,
    menuList: [],
    authInfo: null
  },

  reducers: {
    changLogin(state, action) {
      return {
        ...state,
        isLogin: action.payload,
      };
    },
    saveCurrentUser(state, action) {
      return {
        ...state,
        currentUser: action.payload || {},
      };
    },
    saveMenu(state, action) {
      return {
        ...state,
        menuList: action.payload || [],
      };
    },
    saveRoutes(state, action) {

      return {
        ...state,
        routes: action.routes || [],
      };
    },
    saveAuthInfo(state, action) {
      return {
        ...state,
        authInfo: action.data || {},
      };
    },
    saveResourcesMap(state, action) {
      const list: any[] = action.payload;
      const temp: any = {};
      list.forEach((el: any) => {
        if (el.path) {
          temp[el.path] = el;
        }
      })

      return {
        ...state,
        resourceMap: temp,
      };
    },
  },
};

export default UserModel;
